import { createTypedHooks } from 'easy-peasy';
import type { StoreModel } from '@app/store/types/store-model';

const typedHooks = createTypedHooks<StoreModel>();

export const useStoreActions = typedHooks.useStoreActions;
export const useStoreDispatch = typedHooks.useStoreDispatch;
export const useStoreState = typedHooks.useStoreState;
